<template>
  <div>
    <slot name="data" :pageNumber="pageNumber" />
    <div class="pagination-row flex justify-end">
      <button
        class="pagination-button"
        @click="(pageNumber = pageNumber - 1), clickPag()"
        v-if="pageNumber > 1"
      >
        &lt;-
      </button>
      <span v-for="(item, index) in new Array(6)" :key="index">
        <button
          :class="[
            'pagination-button',
            pageNumber == index + 1 ? 'active' : ''
          ]"
          @click="(pageNumber = index + 1), clickPag()"
        >
          {{ index + 1 }}
        </button>
      </span>
      <button
        class="pagination-button"
        @click="(pageNumber = pageNumber + 1), clickPag()"
      >
        -&gt;
      </button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      pageNumber: 1,
      data: {
        page: "",
        limit: 20
      },
      visible: false
    };
  },
  methods: {
    clickPag() {
      window.scrollTo(0, 0);
      this.data.page = this.pageNumber;
      this.$store.dispatch("events/getPredictionsss", this.data);
    }
  }
};
</script>

<style>
.pagination-button {
  padding: 8px;
  margin: 2px;
  border: solid #00b1da 1px;
  font-size: 1em;
  cursor: pointer;
  border-radius: 20%;
  outline: none !important;
}
.active {
  background-color: grey;
  cursor: auto;
}
.pagination-row {
  padding: 5px 0;
}
.active {
  background-color: #00b1da;
  color: white;
  outline: none !important;
}
</style>
